import { Urls, FeatureFlags, Toggles } from './keys';

export const defaults = {
  [Urls.Host]: 'www.autolist.com',
  [Urls.ComparisonsApi]:
    'https://3hpkht5dzk.execute-api.us-east-1.amazonaws.com/production/api/comparisons',
  [Urls.LookupApi]: 'https://www.autolist.com/api/lookup',
  [Urls.DealerPagesApi]:
    'https://yligh314xb.execute-api.us-east-1.amazonaws.com/production/api/dealer_pages',
  [FeatureFlags.Auth]: true,
  [Toggles.TestAds]: false,
  [Toggles.DebugEvents]: true,
};
